import { useMutation, useQueryClient } from "react-query";
import { useCookie } from "./useCookie";
import { useToast } from "./useToast";
import apiService from "../service/apiService";

export function useReward() {
  const { token } = useCookie("vToken");
  const { toastSuccess, toastError } = useToast();
  const queryClient = useQueryClient();

  const deleteRewardMutation = useMutation({
    mutationFn: (id: string) =>
      apiService.MakeDeleteRequest(`rewards/${id}`, token),

    onSuccess: () => {
      toastSuccess("Reward deleted successfully");

      // 🔁 refresh rewards list
      queryClient.invalidateQueries("getRewards");
    },

    onError: () => {
      toastError("Failed to delete reward");
    },
  });

  return {
    deleteReward: deleteRewardMutation.mutate,
    isDeleting: deleteRewardMutation.isLoading,
  };
}
